var exports = {
  "qr": "footer__pi3i7a",
  "bS": "deniedIcon__L44yHZ",
  "Xn": "deniedText__yI0nT0",
  "Xb": "pendingIcon__5uMNyk",
  "J1": "pendingText__O0hJbB",
  "hH": "expiredIcon__Nb-NAP",
  "JC": "expiredText__apEMUP",
};

module.exports = exports;
